import PageBanner from "../components/ui/PageBanner";
import ServiceIcon from "../components/ui/ServiceIcon";
import opdImg from "../assets/header-2.jpeg";
import "./OutPatientServices.css";

const OUTPATIENT_ITEMS = [
  {
    title: "Cardiology",
    desc: "Heart care consultations for blood pressure, chest pain, heart disease risk, and ongoing cardiac follow-ups.",
    key: "cardiology",
    href: "https://cdc.net.pk/team-group/cardiologist/",
  },
  {
    title: "ENT",
    desc: "Ear, nose, and throat consultations for infections, hearing concerns, sinus issues, and throat conditions.",
    key: "ent",
    href: "https://cdc.net.pk/team-group/ent-specialist",
  },
  {
    title: "Gastroenterology",
    desc: "Digestive health consultations for stomach, liver, gallbladder, and bowel-related concerns.",
    key: "gastroenterology",
    href: "https://cdc.net.pk/team-group/gastroenterologist/",
  },
  {
    title: "Internal Medicine",
    desc: "Adult medicine consultations for complex symptoms, chronic conditions, and coordinated medical care.",
    key: "internal-medicine",
    href: "https://cdc.net.pk/capital-consultant-clinic/",
  },
  {
    title: "Nephrology",
    desc: "Kidney care consultations for kidney disease evaluation, blood pressure management, and renal follow-ups.",
    key: "nephrology",
    href: "https://cdc.net.pk/team-group/medical-specialist/",
  },
  {
    title: "Ophthalmology",
    desc: "Eye care consultations for vision checks, eye infections, and ongoing eye health management.",
    key: "ophthalmology",
    href: "https://cdc.net.pk/capital-consultant-clinic/",
  },
  {
    title: "Pediatrics",
    desc: "Child health consultations for routine check-ups, common illnesses, growth monitoring, and guidance for parents.",
    key: "pediatrics",
    href: "https://cdc.net.pk/team-group/pediatrician/",
  },
  {
    title: "Preventive & Wellness Care",
    desc: "Health checks, screenings, and guidance focused on early detection and long-term wellbeing.",
    key: "preventive",
    href: "https://cdc.net.pk/team-group/vaccination-immunity-center/",
  },
  {
    title: "Diagnostics Support (CDC)",
    desc: "Capital Diagnostic Centre (CDC) provides sample collection, lab testing, and imaging support to help clinicians diagnose, monitor, and plan treatment efficiently with timely reporting and coordinated clinical follow-up.",
    key: "diagnostics",
    href: "https://cdc.net.pk/capital-consultant-clinic/",
  },
  {
    title: "Laboratory",
    desc: "Laboratory services including hematology and related testing support for accurate diagnosis and follow-up.",
    key: "laboratory",
    href: "https://cdc.net.pk/service/hematology/",
  },
];

export default function OutPatientServices({ setPage }) {
  return (
    <>
      <PageBanner title="Out-Patient Services" crumbs={["Home", "Our Services", "Out-Patient"]} />

      <section className="section">
        <div className="section-inner">
          <div className="outpatient__layout">
            <div className="outpatient__left">
              <h3 className="section-title">Out Patient Service</h3>
              <p className="section-text">
          Outpatient services are provided adjacent to Capital Care International Hospital (CCIH) With seamless diagnostic support from Capital Diagnostic Centre (CDC), patients can conveniently access lab tests, imaging, and timely reporting. This coordinated setup helps clinicians assess, monitor, and plan effective treatment for better patient care.
                {" "}
                <a
                  href="https://cdc.net.pk/capital-consultant-clinic/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn more about CDC services
                </a>
                .
              </p>
              <div className="outpatient__btns">
                <button type="button" className="btn-outline" onClick={() => setPage("services")}>
                  Back to Services
                </button>
              </div>
            </div>

            <div className="outpatient__right">
              <div className="outpatient__img-wrap" aria-hidden="true">
                <img className="outpatient__img" src={opdImg} alt="" loading="lazy" />
              </div>
            </div>
          </div>

          <h3 className="section-title">CDC Services</h3>
          <div className="outpatient__grid">
            {OUTPATIENT_ITEMS.map((it) => (
              <div key={it.title} className="outpatient__card card">
                <div className="outpatient__icon" aria-hidden="true">
                  <ServiceIcon name={it.key} />
                </div>
                <h3 className="outpatient__title">{it.title}</h3>
                <p className="outpatient__text">{it.desc}</p>
                {it.href && (
                  <a className="outpatient__link" href={it.href} target="_blank" rel="noopener noreferrer">
                    View details
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
